import { OfferModule } from './offer-ence/offer.module';
import { NgModule } from '@angular/core';
import { NavbarModule } from './navbar/navbar.module';
import { FooterModule } from './footer/footer.module';
import { PrivacityModule } from './privacity/privacity.module';
import { LegalModule } from './legal/legal.module';
import { MonteModule } from './monte/monte.module';

@NgModule({
    imports:[
        NavbarModule,
        FooterModule,
        PrivacityModule,
        LegalModule,
        OfferModule,
        MonteModule
    ],
    exports:[        
        NavbarModule,
        FooterModule,
        PrivacityModule,
        LegalModule,
        OfferModule,
        MonteModule
    ],
    declarations: []
})
export class ComponentsModule { }